import { perfLog } from './perfLog';
const inFlight = new Map();
function isContainerInfo(value) {
    const info = value;
    return (!!info &&
        typeof info.id === 'string' &&
        typeof info.scanCount === 'number' &&
        info.scanCount > 0 &&
        typeof info.startedAt === 'number' &&
        info.startedAt > 0);
}
/**
 * Record that one scan of a container finished displaying. Emits the summary
 * once every scan has reported. Safe to call with undefined — non-container
 * formats pass nothing and are ignored.
 */
export function noteContainerScanLoaded(container, vertexCount) {
    if (!isContainerInfo(container)) {
        return;
    }
    let progress = inFlight.get(container.id);
    if (!progress) {
        progress = { info: container, completed: 0, vertices: 0 };
        inFlight.set(container.id, progress);
    }
    progress.completed++;
    progress.vertices += typeof vertexCount === 'number' ? vertexCount : 0;
    if (progress.completed < container.scanCount) {
        return;
    }
    // A scan that errors out never reports, so its container stays parked here
    // rather than logging a total that would be wrong anyway.
    inFlight.delete(container.id);
    const totalMs = Math.max(0, Date.now() - container.startedAt);
    const scans = `${container.scanCount} scan${container.scanCount === 1 ? '' : 's'}`;
    perfLog(`⏱️ PERF[${container.kind}/all ${container.name}] total ${totalMs.toFixed(1)}ms` +
        `  (${scans} · ${progress.vertices.toLocaleString()} pts)`);
}
/** Test hook: drop any partially-completed containers. */
export function resetContainerPerf() {
    inFlight.clear();
}
